import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CheckboxItem } from '../../../components/shared/checkbox-group/checkbox-item';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-checkbox-group',
    templateUrl: './checkbox-group.component.html',
    styles: [],
    standalone: false
})
export class CheckboxGroupComponent implements OnInit, OnChanges {
  @Input() public options: CheckboxItem[];
  @Input() public selectedValues: string[];
  @Output() toggle = new EventEmitter<string[]>();

  public form: UntypedFormGroup;

  public get items(): UntypedFormArray {
    return this.form.get("items") as UntypedFormArray;
  }

  constructor(private readonly fb: UntypedFormBuilder) {
    this.form = this.fb.group({
      items: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(value => {
      const checkedOptionValues = new Array<string>();

      for (let index = 0; index < this.items.length; index++) {
        const isOptionChecked = this.items.get(index.toString()).value;
        if (isOptionChecked) {
          const currentOptionValue = this.options[index].value;
          checkedOptionValues.push(currentOptionValue);
        }
      }

      this.toggle.emit(checkedOptionValues);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options && changes.options.currentValue) {
      this.items.clear();
      changes.options.currentValue.forEach(x => {
        this.items.push(this.fb.control(false));
      });
    }

    if (changes.selectedValues && changes.selectedValues.currentValue) {
      changes.selectedValues.currentValue.forEach(value => {
        const index: number = this.options.findIndex(x => x.value === value);
        if (index >= 0)
          this.items.get(index.toString()).setValue(true);
      })

      this.toggle.emit(this.selectedValues);
    }
  }
}
